export default function Section2() {
  return (
    <div className="Section2">
      <div className="section2-container">
        <div className="md:w-[80%] my-[24px] mx-5 md:my-0 md:mx-auto text-center">
          <h1 className="text-[24px] md:text-[34px] font-bold leading-[32px] md:leading-[41px] text-[#151515] mt-[40px]">
            Performance Marketing Services in Dubai
          </h1>

          <p className="pt-[1%] leading-[20px] text-[16px] font-open text-[#535353]">
            At Mean3, we focus on performance marketing in Dubai. Our services drive real, measurable
growth for businesses. We specialize in custom strategies that help you achieve your goals. We
create our performance marketing services to ensure efficiency. Whether you run a small startup
or a well-known brand, our expert marketers are here to help. We focus on your digital
campaigns. We use the best performance marketing channels. We aim to improve every aspect
of your marketing. This way, you can connect with your target audience and increase profitable
conversions.
          </p>
        </div>

        <div className="flex flex-col md:flex-row px-5 md:px-[30px] mb-[4%] md:my-0 md:mt-[68px] md:items-center md:justify-evenly">
          <div className="md:w-[36%]">
            <h2 className="md:text-[34px] font-bold my-[0.67em] text-[24px] leading-[32px] md:leading-[41px] text-[#DA2128] pb-[2%]">
              Online Performance Marketing Solutions for Your Store
            </h2>

            <p className="pb-[1%] mb-5 leading-[20px] text-[16px] font-open text-[#373737]">
              We’re a top-performing marketing services company. We know e-commerce businesses need
unique marketing solutions to shine in a busy market. Our e-commerce marketing strategies
help you stand out online. We aim to boost sales with targeted campaigns. Partnering with a
dedicated digital marketing agency can make your marketing easier. This can improve your
conversions. Our team of marketing experts builds custom campaigns. We focus on paid
search, social media, and display ads. This helps increase traffic, enhance customer targeting,
and grow your store's revenue.
            </p>
            <h2 className="md:text-[34px] font-bold my-[0.67em] text-[24px] leading-[32px] md:leading-[41px] text-[#DA2128] pb-[2%]">
              Expert Performance Marketing Consultant and Agency Services
            </h2>

            <p className="pb-[1%] mb-5 leading-[20px] text-[16px] font-open text-[#373737]">
              At Mean3, we have a full range of performance marketing services. We adapt to fit your
business needs perfectly. We’re here to assist you! Whether you want a consultant to improve
your strategies or need full service for your digital campaigns, we can help. Our team of
performance marketers is here to support you. We team up to build smart strategies. Then, we
put them into action across different marketing channels. Let us help you get results that grow
your business and support your long-term success.
            </p>
          </div>

          <div className="w-full image-cont md:w-auto">
            <img className="w-full md:w-auto" src="assets/artboard-performance-marketing.png"></img>
          </div>
        </div>

        <div className="line my-[55px] md:my-[4%] mx-auto w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
      </div>
    </div>
  );
}
